__turbopack_context__.v({
  "box": "ChartAccordion-module__wABrMq__box",
  "boxArrow": "ChartAccordion-module__wABrMq__boxArrow",
  "boxContentBtnGrp": "ChartAccordion-module__wABrMq__boxContentBtnGrp",
  "boxContentclosed": "ChartAccordion-module__wABrMq__boxContentclosed",
  "boxHeader": "ChartAccordion-module__wABrMq__boxHeader",
  "boxPriceChangeAbs": "ChartAccordion-module__wABrMq__boxPriceChangeAbs",
  "boxPriceChangeRel": "ChartAccordion-module__wABrMq__boxPriceChangeRel",
  "boxPriceContainer": "ChartAccordion-module__wABrMq__boxPriceContainer",
  "boxTitle": "ChartAccordion-module__wABrMq__boxTitle",
  "error": "ChartAccordion-module__wABrMq__error",
  "negative": "ChartAccordion-module__wABrMq__negative",
  "positive": "ChartAccordion-module__wABrMq__positive",
});
